import React, {Component} from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';

class PageNotFound extends Component {

    render () {

        return (

            <div>
                <Header />

                <section id="report-section">
                    <div className="container">
                        <div className="report-title">
                            <p className="h3">Page Not Found</p>
                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        )
    }
} 

export default PageNotFound;